exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family={{ selectedFont }});", ""]);

// module
exports.push([module.id, "*[data-v-34a0746b] {\n  color: #3d4852;\n}\n.qp-small-logo[data-v-34a0746b] {\n  width: 180px;\n  height: 151px;\n}\n.qp-medium-logo[data-v-34a0746b] {\n  width: 220px;\n  height: 185px;\n}\n.qp-large-logo[data-v-34a0746b] {\n  width: 260px;\n  height: 218px;\n}\n", ""]);

// exports
